module.exports = __webpack_public_path__ + "static/img/tu9.8a35fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu9.png
// module id = WTxD
// module chunks = 128